import { Button } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { PlusOutlined, ReadOutlined } from '@ant-design/icons'

import * as styles from './collection-list-header.css';

export const CollectionListHeader = ({
  onCreate,
}: {
  onCreate: () => void;
}) => {
  const t = useI18n();

  return (
    <div className={styles.collectionListHeader}>
      <div className={styles.collectionListHeaderTitle}>
        <ReadOutlined />
        {t['com.affine.collections.header']()}
      </div>
      <Button
        className={styles.newCollectionButton}
        onClick={onCreate}
        data-testid="all-collection-new-button"
        style={{ background: '#1c64ff', color: 'white', padding: '7px 15px' }}
      >
        <PlusOutlined style={{ marginRight: '5px' }} />
        {t['com.affine.collections.empty.new-collection-button']()}
      </Button>
    </div>
  );
};
